import Vue from 'vue'
import { i18n } from '@/plugins/vuei8n'
import moment from 'moment'

const app = new Vue({
    i18n,
})

const defaultRequestDetail = {
    address: {
        apartment: '',
        city: '',
        country: '',
        description: '',
        entrance: '',
        house: '',
        street: '',
    },
    client: {
        big_image: '',
        email: '',
        first_name: '',
        id: '',
        last_name: '',
        notification_key: '',
        payment_type: '',
        paypal_enabled: '',
        phone: '',
        small_image: '',
    },
    contact: {
        email: '',
        first_name: '',
        last_name: '',
        phone: '',
    },
    date_from: 1527238800,
    date_till: '',
    description: '',
    executors: [],
    history: [],
    id: '',
    media: [],
    price: '',
    service: {
        id: '',
        title: '',
        icon: '',
        image: '',
        color: '',
    },
    status: '',
    executor: '',
}

const localState = {
    isActive: 'mount',
    showDetails: false,
    detail: new Date().getDate(),
    day: new Date(),
    monthRequests: {},
    updateCalendar: false,
    requestDatail: { ...defaultRequestDetail },
    config: {
        startWeek: 'Tuesday',
        months: [
            app.$t('calendar.january'),
            app.$t('calendar.february'),
            app.$t('calendar.march'),
            app.$t('calendar.april'),
            app.$t('calendar.may'),
            app.$t('calendar.june'),
            app.$t('calendar.july'),
            app.$t('calendar.august'),
            app.$t('calendar.september'),
            app.$t('calendar.october'),
            app.$t('calendar.november'),
            app.$t('calendar.december'),
        ],
        weekdays: [
            app.$t('calendar.monday'),
            app.$t('calendar.tuesday'),
            app.$t('calendar.wednesday'),
            app.$t('calendar.thursday'),
            app.$t('calendar.friday'),
            app.$t('calendar.saturday'),
            app.$t('calendar.sunday'),
        ],
    },
    months: [{
        id: 0,
        text: app.$t('calendar.january'),
    },
    {
        id: 1,
        text: app.$t('calendar.february'),
    },
    {
        id: 2,
        text: app.$t('calendar.march'),
    },
    {
        id: 3,
        text: app.$t('calendar.april'),
    },
    {
        id: 4,
        text: app.$t('calendar.may'),
    },
    {
        id: 5,
        text: app.$t('calendar.june'),
    },
    {
        id: 6,
        text: app.$t('calendar.july'),
    },
    {
        id: 7,
        text: app.$t('calendar.august'),
    },
    {
        id: 8,
        text: app.$t('calendar.september'),
    },
    {
        id: 9,
        text: app.$t('calendar.october'),
    },
    {
        id: 10,
        text: app.$t('calendar.november'),
    },
    {
        id: 11,
        text: app.$t('calendar.december'),
    },
    ],
    showDay: false,
    monthMetrics: null,
    dayMetric: null,
    week: null,
    weekTitle: null,
}

const actions = {
    async getCalendarsData({
        state,
        dispatch,
        commit,
    }, data) {
        let request = ''
        if (data.service_id) {
            request = `/requests?from=${data.firstDay}&till=${data.lastDay}&service_id=${data.service_id}`
        } else if (data.service_id && !data.employee) {
            request = `/requests?from=${data.firstDay}&till=${data.lastDay}&service_id=${data.service_id}`
        } else if (!data.service_id && data.employee) {
            request = `/requests?from=${data.firstDay}&till=${data.lastDay}&search=${data.employee}`
        } else if (data.executor_id) {
            request = `/requests?from=${data.firstDay}&till=${data.lastDay}&executor_id=${data.executor_id}`
        } else {
            request = `/requests?from=${data.firstDay}&till=${data.lastDay}`
        }

        if (data.office_id && data.office_id !== 'all') {
            request += `&office_id=${data.office_id}`
        }

        const response = await this.$api.orders.fetch(request)

        state.monthRequests = {}

        const serviceQuery = data?.service_id
            ? `&service_id=${data.service_id}`
            : ''
        const masterQuery = data?.executor_id ? `&master_id=${data.executor_id}` : ''
        const officeQuery = (data?.office_id && data?.office_id !== 'all') ? `&office_id=${data.office_id}` : ''

        const metrics = await this.$api.metrics.daily(
            `?from=${data.firstDay}&till=${data.lastDay}${serviceQuery}${masterQuery}${officeQuery}`,
        )

        for (const item in metrics.data) {
            response.data.requests[item] = response.data.requests[item] || {}
            response.data.requests[item].metrics = metrics.data[item]
        }

        commit('setMonthData', {
            data: response.data.requests,
        })

        delete window.request
        window.request = { ...response.data.requests }

        commit('metrics/setMonthRequest', window.request, {
            root: true,
        })
        if (response.data.service !== undefined) {
            this.commit('setService', response.data.service.id)
        }

        commit('setExecutor', response.data.executor)

        await dispatch('getMonthMetrics', {
            from: data.firstDay,
            till: data.lastDay,
            serviceQuery,
            masterQuery,
            officeQuery,
        })
        commit('metrics/setDayMetrics', {
            root: true,
        })
    },

    async getRequestDetails({
        state,
        commit,
    }, id) {
        try {
            commit('requesDetailsReset')
            const response = await this.$api.orders.fetchById(id)
            state.requestDatail = response.data
        } catch (err) {
            console.log(err)
        }
    },
    async getRequestWeekDetails({
        commit,
    }, form) {
        try {
            const response = await this.$api.orders.fetchWeekRequests(form)
            commit('setWeek', response)

            const key = Object.keys(response.data)[0]
            const date = moment(key).week()

            commit('setWeekTitle', `${date} - ${date + 1}`)
        } catch (err) {
            console.log(err)
        }
    },

    async getMonthMetrics(_, {
        from,
        till,
        serviceQuery,
        masterQuery,
        officeQuery,
    }) {
        const response = await this.$api.metrics.month(
            `?from=${from}&till=${till}${serviceQuery}${masterQuery}${officeQuery}`,
        )

        this.commit('metrics/setState', {
            key: 'monthMetrics',
            value: response.data,
        })
    },

    async updateRequestDetails({
        commit,
    }, {
        id,
        data,
    }) {
        try {
            const response = await this.$api.orders.update(id, data)
            commit('requesDetailsReset')
            return response
        } catch (err) {
            console.log(err)
        }
    },

    async updateRequestStatus(_, {
        id,
        status,
    }) {
        try {
            const response = await this.$api.orders.updateStatus(id, {
                status,
            })
            return response.status === 200
        } catch (err) {
            console.log(err)
        }
    },

    async updateRequestComment(_, {
        id,
        comment,
    }) {
        try {
            if (!!comment === false) {
                return true
            }

            const response = await this.$api.orders.updateComment(id, {
                comment,
            })
            return response.status === 200
        } catch (err) {
            console.log(err)
        }
    },

    async sendRequestInvoice(_, id) {
        try {
            await this.$api.orders.sendbill(id)
        } catch (err) {
            console.log(err)
        }
    },

    async deleteRequest({
        commit,
    }, id) {
        try {
            await this.$api.orders.remove(id)
            commit('requesDetailsReset')
        } catch (err) {
            console.log(err)
        }
    },
}

const mutations = {
    setMonthData(state, {
        data,
    }) {
        state.monthRequests = Object.entries(data).reduce((accum, item, index) => {
            const localAcc = { ...accum }
            const day = new Date(item[0] * 1000)
            const key = day.getDate()

            if (key > index + 1) {
                return localAcc
            }

            if (!accum.hasOwnProperty(key)) {
                // eslint-disable-next-line prefer-destructuring
                localAcc[key] = item[1]
            }

            return localAcc
        }, {})
    },
    requesDetailsReset(state) {
        state.requestDatail = { ...defaultRequestDetail }
    },
    setUpdateCalendar: (state) => {
        state.updateCalendar = !state.updateCalendar
    },
    setOrderData: (state, {
        showDetails,
        isActive,
        detail,
        day,
    }) => {
        state.showDetails = showDetails
        state.isActive = isActive
        state.detail = detail
        state.day = day
    },
    setShowDay: (state, v) => {
        state.showDay = v
    },
    setDay: (state, v) => {
        state.day = v
    },
    setExecutor: (state, v) => {
        state.requestDatail.executor = v
    },
    setMonthMetrics: (state, v) => {
        state.monthMetrics = v
    },
    setDayMetric: (state, v) => {
        state.dayMetric = v
    },
    setDayMetrics: (state, v) => {
        state.dayMetrics = v
    },
    setWeek: (state, v) => {
        state.week = v
    },
    setWeekTitle: (state, v) => {
        state.weekTitle = v
    },
}

const getters = {
    monthRequestsGetters: (state) => state.monthRequests,
    requestDetailsGetters: (state) => state.requestDatail,
    isActiveGetters: (state) => state.isActive,
    executorGetters: (state) => state.requestDatail.executor,
    configGetters: (state) => state.config,
    monthsGetters: (state) => state.months,
    updateCalendarGetters: (state) => state.updateCalendar,
    dayGetters: (state) => state.day,
    showDayGetters: (state) => state.showDay,
    monthMetricsGetters: (state) => state.monthMetrics,
    dayMetricGetters: (state) => state.dayMetric,
    dayMetricsGetters: (state) => state.dayMetrics,
    weekGetters: (state) => state.week,
    weekTitleGetters: (state) => state.weekTitle,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
